/**
 * The states that are a PAGE — no Stage, no Rail, the page owns the surface.
 * 'tournament' joined them in M4 (standings, pairings, the arena lobby and the
 * leaderboard got the whole width) and LEFT them again in fix G, 2026-10-06:
 * the owner decided there is no need for a tournament lobby without a board —
 * everything the idle/joining experience needs renders inside the ordinary
 * Stage + Rail now (`Body.tsx`, `rail/Rail/model.ts selectRailMode`,
 * `stage/TournamentIdle`). Shared with `chrome/useChromeHidden` (D8 revised
 * 2026-10-06): "a board is on screen" is defined as exactly NOT one of these,
 * so the two can never disagree about when the shell's header should be gone.
 *
 * Typed `readonly string[]` rather than a narrower literal union on purpose —
 * `Body.tsx`'s `PAGE_STATES.includes(railState)` and `isPageState`'s own
 * generic-`string` signature both need to call `.includes` against whatever
 * `RailState` (a wider union) a caller hands in.
 */
export const PAGE_STATES: readonly string[] = [
  'home',
  'seeking',
  'challengeOut',
] as const;

export const isPageState = (railState: string): boolean =>
  PAGE_STATES.includes(railState);

export default PAGE_STATES;
